import { Component, OnInit } from "@angular/core";
import { AudioCourse, Course } from "../../models/course";
import { ApiService } from "../../lib/api.service";
import { ModalService } from "../../lib/modal.service";
import { LogService } from "../../lib/log.service";
import { CourseAdminEditComponent } from "../../components/admin/course-admin-edit/course-admin-edit.component";
import { CourseAdminAudioEditComponent } from "../../components/admin/course-admin-audio-edit/course-admin-audio-edit.component";
import { CourseBurningQuestionEditComponent } from "../../components/admin/course-burning-question-edit/course-burning-question-edit.component";
import * as _ from "lodash";
import { Router } from "@angular/router";
import { DailySeriesCreateComponent } from "app/components/admin/daily-series-create/daily-series-create.component";
import { DailySeriesAddComponent } from "app/components/admin/daily-series-add/daily-series-add.component";

@Component({
	selector: "admin-course-listing",
	templateUrl: "admin-course-listing.component.html",
	styleUrls: ["./admin-course-listing.component.scss"],
})
export class AdminCourseListingPage implements OnInit {
	isLoaded: boolean = false;
	courses: Course[] = [];
	audioCourses: AudioCourse[] = [];
	storyList: any[];
	burningQuestionList: any[];
	dailyList: any[];
	dailyGroups: any = [];
	cols: any = [];
	selectedGroupId: number;
	filterDailycontent: any[];
	public constructor(
		private api: ApiService,
		private modalService: ModalService,
		private logService: LogService,
		private router: Router
	) {this.cols.push('');}

	ngOnInit() {
		this.getCourseList();
		this.getStoryList();
		this.getBurningList();
		this.getGroupDropdown();
	}

	getGroupDropdown(){
		this.isLoaded = false;
		this.api.get("series/dailyseries/getgroups").subscribe(
			(result: any) => {
				this.isLoaded = true;
				if (result) {
					if(result.length != 0){
					this.dailyGroups = result;
					this.selectedGroupId = this.dailyGroups[0].ID
					this.getDailyList(this.selectedGroupId);
					}else{
						this.dailyList = [];
						this.dailyGroups = [];
					}
				}
				this.isLoaded = true;
			},
			(error: any) => {
				this.logService.debug(
					"Error getting series. " + error.message
				);
				this.isLoaded = true;
			}
		);
	}
	getCourseList(){
		this.courses = [];
		this.api.get("series/serieslisting?list=all").subscribe(
			(result: any) => {
				this.isLoaded = true;
				if (result.data) {
					const resCourses = result.data;
					for (var key in resCourses) {
						this.courses.push(
							new Course({
								id: resCourses[key].ID,
								label: resCourses[key].Label,
								key:  resCourses[key].Key,
								active:  resCourses[key].Active
							})
							// new Course(resCourses[key])
						);
					}
				}
				this.isLoaded = true;
			},
			(error: any) => {
				this.logService.debug(
					"Error getting series. " + error.message
				);
				this.isLoaded = true;
			}
		);
	}
	getStoryList() {
		this.storyList = [];
		this.api.get("series/adminstories").subscribe(
			(result: any) => {
				this.isLoaded = true;
				if (result) {
					if(result.length != 0){
					const resCourses = result;
						for (var key in resCourses) {
							this.storyList.push(
								new AudioCourse({
									id: resCourses[key].ID,
									titleen: resCourses[key].Title_en,
									authoren:  resCourses[key].Author_en,
									active:  resCourses[key].Active,
									category: resCourses[key].categorydetails.Title,
								})
							);
						}
					}else{
						this.storyList = [];
					}
				}
				this.isLoaded = true;
			},
			(error: any) => {
				this.logService.debug(
					"Error getting series. " + error.message
				);
				this.isLoaded = true;
			}
		);	
	}
	getBurningList() {
		this.burningQuestionList = [];
		this.api.get("series/adminburningquestions").subscribe(
			(result: any) => {
				this.isLoaded = true;
				if (result) {
					if(result.length != 0){
					const resCourses = result;
						for (var key in resCourses) {
							this.burningQuestionList.push(
								new AudioCourse({
									id: resCourses[key].ID,
									titleen: resCourses[key].Title_en,
									authoren:  resCourses[key].Author_en,
									active:  resCourses[key].Active,
									category: resCourses[key].categorydetails.Title,
								})
							);
						}
					}else{
						this.burningQuestionList = [];
					}
				}
				this.isLoaded = true;
			},
			(error: any) => {
				this.logService.debug(
					"Error getting series. " + error.message
				);
				this.isLoaded = true;
			}
		);	
	}
	getDailyList(id) {
		this.dailyList = [];
		this.api.get("admin/series/dailyseries?group="+id).subscribe(
			(result: any) => {
				this.isLoaded = true;
				if (result) {
					const resCourses = result;
					for (var key in resCourses) {
						this.dailyList.push(
							new AudioCourse({
								id: resCourses[key].ID,
								category_id:resCourses[key].CategoryID,
								category_title:resCourses[key].category.Title,
								quote_en: resCourses[key].QuoteEn,
								quote_es:  resCourses[key].QuoteEs,
								quote_fr:  resCourses[key].QuoteFr,
							})
						);
					}
					this.filterDailycontent = this.dailyList;
				}
				this.isLoaded = true;
			},
			(error: any) => {
				this.logService.debug(
					"Error getting series. " + error.message
				);
				this.isLoaded = true;
			}
		);
	}

	onSelectTab(index: number) {
		if (index === 0) {
			this.isLoaded = false;
			this.getCourseList();		
		} else if(index === 1) {
			this.isLoaded = false;
			this.getStoryList();			
		} else if(index === 2) {
			this.isLoaded = false;
			this.getBurningList();
		}
	}

	doAdd(series){
		this.modalService.setCloseOnClickAway(false);
		this.modalService.showComponent(DailySeriesAddComponent, {
			data: this.selectedGroupId,
		}).afterClosed().subscribe(result => {
			if (result.data) {
				this.getDailyList(result.groupId);
			}
		});
	}

	valueChange(event) {
		this.isLoaded = false;
		this.selectedGroupId = event.value;
		this.getDailyList(this.selectedGroupId );
	}

	filterValue(i) {

		let filterValue = this.cols[i].toLowerCase();
		let empty = this.reset();

		let key = '';
		if (i == 0) {
			key = 'categorytitle';
		}
		else {
			return;
		}

		if (!empty) {
					let cols = this.cols;
					let resp = _.filter(this.filterDailycontent, (o) => {
						const val = o[key];
						return typeof val === 'string' && val.toLowerCase().includes(filterValue);
					});
					this.dailyList = resp;
				} else {
			this.dailyList = this.filterDailycontent;
		}
	}

	reset() {
		for (let i = 0; i < this.cols.length; i++) {
			if (this.cols[i] !== '') {
				return false;
			}
		}
		return true;
	}

	doCreate(type) {
		if (type === 'video') {
			this.modalService.setCloseOnClickAway(false);
			this.modalService.showComponent(CourseAdminEditComponent, null).afterClosed().subscribe(result => {
				if (result) {
					this.getCourseList();
				}
			});
		} else if (type === 'stories') {
			this.modalService.setCloseOnClickAway(false);
			this.modalService.showComponent(CourseAdminAudioEditComponent, null).afterClosed().subscribe(result => {
				if (result) {
					this.getStoryList();
				}
			});
		} else if (type === 'burningquestion') {
			this.modalService.setCloseOnClickAway(false);
			this.modalService.showComponent(CourseBurningQuestionEditComponent, null).afterClosed().subscribe(result => {
				if (result) {
					this.getBurningList();
				}
			});
		} else if(type === 'daily') {
			this.modalService.setCloseOnClickAway(false);
			this.modalService.showComponent(DailySeriesCreateComponent, {
				data: null,
				groups: this.dailyGroups,
				mode: 'create'
			}).afterClosed().subscribe(result => {
				if (result) {
					this.getGroupDropdown();
				}
			});
		}
	}

	onEdit(id,type) {
		if(type === 'video'){
			this.modalService.setCloseOnClickAway(false);
			const modal = this.modalService.showComponent(CourseAdminEditComponent, id);
			modal.beforeClosed().subscribe((data:any) => {
				if(data){
					this.getCourseList();
				}
			});
		} else if(type === 'stories') {
			this.modalService.setCloseOnClickAway(false);
			const modal = this.modalService.showComponent(CourseAdminAudioEditComponent, id);
			modal.beforeClosed().subscribe((data:any) => {
				if(data){
					this.getStoryList();
				}
			});
		} else if(type === 'burningquestion') {
			this.modalService.setCloseOnClickAway(false);
			const modal = this.modalService.showComponent(CourseBurningQuestionEditComponent, id);
			modal.beforeClosed().subscribe((data:any) => {
				if(data){
					this.getBurningList();
				}
			});
		} else if(type === 'daily') {
			this.modalService.setCloseOnClickAway(false);
			const modal = this.modalService.showComponent(DailySeriesCreateComponent, {
				data: id,
				groups: null,
				mode: 'update'
			});
			modal.beforeClosed().subscribe((data:any) => {
				if(data){
					this.getDailyList(this.selectedGroupId );
				}
			});
		}
		
	}
	delete(courseId,type) {
		if(type === 'video'){
			this.modalService.showConfirmation("Delete", "Are you sure you want to delete this series?").afterClosed().subscribe(result => {
				if (result) {
					this.api.delete('series/' + courseId).subscribe(
						(result: any) => {
							let index = _.findIndex(this.courses, { id: courseId });
							this.courses.splice(index, 1);
							this.modalService.showAlert('Success', 'series has been removed successfully.');
						},
						(error: any) => {
							this.logService.error('Error deleting.');
						}
					);
				}
			});
		} else if(type === 'stories') {
			this.modalService.showConfirmation("Delete", "Are you sure you want to delete this stories voice series?").afterClosed().subscribe(result => {
				if (result) {
					this.api.delete('series/story/' + courseId).subscribe(
						(result: any) => {
							let index = _.findIndex(this.storyList, { id: courseId });
							this.storyList.splice(index, 1);
							this.modalService.showAlert('Success', 'Story has been removed successfully.');
						},
						(error: any) => {
							this.logService.error('Error deleting.');
						}
					);
				}
			});
		} else if(type === 'burningquestion'){
			this.modalService.showConfirmation("Delete", "Are you sure you want to delete this burning question voice series?").afterClosed().subscribe(result => {
				if (result) {
					this.api.delete('series/burningquestion/' + courseId).subscribe(
						(result: any) => {
							let index = _.findIndex(this.burningQuestionList, { id: courseId });
							this.burningQuestionList.splice(index, 1);
							this.modalService.showAlert('Success', 'Burning Question has been removed successfully.');
						},
						(error: any) => {
							this.logService.error('Error deleting.');
						}
					);
				}
			});
		}
	}

	viewRoute(type, id){
		this.router.navigate([`/app/series/voices/${type}/${id}`])
	}
}
